// Copyright (c) 2017 Deere & Company

import RecordAuditModal from './record-audit-modal';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    actualAuditDate: state.tcsm.recordAudit.auditRecording.actualAuditDate,
    auditNumber: state.tcsm.recordAudit.auditRecording.auditNumber,
    auditResults: state.tcsm.recordAudit.auditRecording.auditResults,
    city: state.tcsm.recordAudit.auditRecording.city,
    file: state.tcsm.recordAudit.auditRecording.file,
    isVisible: state.tcsm.recordAudit.isRecordAuditModalVisible,
    leadAccountName: state.tcsm.recordAudit.auditRecording.leadAccountName,
    state: state.tcsm.recordAudit.auditRecording.state
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => ({
    ...stateProps,
    actions: {
        ...dispatchProps
    },
    routeParams: parentProps.routeParams
});

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(RecordAuditModal);



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/components/record-audit-modal/index.js